export const PAGE_SIZE = 20;

export function getItemKey(item = {}) {
  return item?._id || item?.worker?._id || '';
}

export function uniqByKey(list = []) {
  const map = new Map();
  list.forEach(item => {
    const key = getItemKey(item);
    if (!key) {
      return;
    }
    map.set(key, item);
  });
  return Array.from(map.values());
}

export function getVisibleLists(source = {}, page = 1, pageSize = PAGE_SIZE) {
  const quotedList = source.quotedList || [];
  const assignableList = source.assignableList || [];
  const limit = page * pageSize;
  const quotedVisibleCount = Math.min(quotedList.length, limit);
  const assignableVisibleCount = Math.max(0, limit - quotedVisibleCount);

  return {
    list: quotedList.slice(0, quotedVisibleCount),
    workerList: assignableList.slice(0, assignableVisibleCount),
    hasMore: quotedList.length + assignableList.length > limit,
  };
}

export function resolvePaginationMode(res = {}, pageSize = PAGE_SIZE) {
  if (typeof res.hasMore === 'boolean' || typeof res.totalPages === 'number' || typeof res.page === 'number') {
    return 'server';
  }
  if (typeof res.totalCount === 'number') {
    return 'server';
  }
  return ((res.list || []).length + (res.workerList || []).length) > pageSize ? 'client' : 'server';
}

export function resolveServerHasMore(res = {}, currentPage = 1, pageSize = PAGE_SIZE, currentCount = 0) {
  if (typeof res.hasMore === 'boolean') {
    return res.hasMore;
  }
  if (typeof res.totalPages === 'number') {
    return currentPage < res.totalPages;
  }
  if (typeof res.totalCount === 'number') {
    return currentCount < res.totalCount;
  }
  return ((res.list || []).length + (res.workerList || []).length) >= pageSize;
}
